import { Component, OnDestroy, OnInit } from '@angular/core';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { AuthService } from '@carm/_auth/spartacus/core/auth';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { MetadataService } from '@carm/_core/metadata/services';
import { BaseComponent } from '@carm/_utils/base.component';
import { Observable } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'carm-main-header-lang-section',
  templateUrl: './main-header-lang-section.component.html',
  styleUrls: ['./main-header-lang-section.component.scss'],
})
export class MainHeaderLangSectionComponent extends BaseComponent implements OnInit, OnDestroy {

  isLoggedIn$: Observable<boolean>;

  constructor(private authService: AuthService,
    private metadataService: MetadataService,
    private userService: UserService,
    private router: CarmRouter) {
      super();
  }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isUserLoggedIn().pipe(takeUntil(this.destroy$));
  }

  onLogout() {
    this.authService.logout();
    this.userService.logOut();
    this.metadataService.resetMetadata();
    this.authService.isUserLoggedIn().pipe(
      takeUntil(this.destroy$),
      filter((isLoggedIn) => isLoggedIn === false), take(1))
      .subscribe(() => {
      this.router.carmNavigate([RoutesConst.GCKey]);
    });
  }
}
